import React from 'react';
import ClassManagementContainer from '../../schedule/classManagement/ClassManagementContainer';

const ModalSchedule = ({ ...props }) => <ClassManagementContainer origin="table" {...props} />;

export default ModalSchedule;
